module.exports = "/_next/static/images/Frame-2df42ddfd46a18d65a926a3415b193bd.webp";